import React from 'react';
import FittedImage from 'react-fitted-img';
import './StaticBanner.css';

export interface IStaticBannerProps extends React.HTMLProps<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  bannerImg: any;
  className?: string;
}

export default function StaticBanner({
  title,
  subtitle,
  bannerImg,
  className
}: IStaticBannerProps) {
  return (
    <div className={`static-banner ${className}`}>
      <div className="container">
        <div className="title-block">
          {title && <h1 className="title">{title}</h1>}
          {subtitle && <p className="subtitle">{subtitle}</p>}
        </div>
      </div>

      {!!bannerImg &&
        <FittedImage
          className="fitted-img"
          decoding="async"
          fit='cover'
          src={bannerImg.src}
          srcSet={`${bannerImg.src} 240w`}
          sizes="
            (min-width: 320px) 320px,
            (min-width: 768px) 768px,
            (min-width: 1024px) 1024px,
            (min-width: 1200px) 1200px
          "
          {...bannerImg} />
      }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/StaticBanner/index.tsx